import type { ICompany } from 'types/company';

// trim + lower case — porównania kodów (PL vs pl)
function norm(code: string): string {
  return code.trim().toLowerCase();
}

export function companySupportedLanguageCodes(
  company: ICompany | null | undefined
): string[] {
  if (!company) return [];

  // źródło: available_language_codes z API (DefaultSettings tak samo)
  if (company.available_language_codes?.length) {
    return company.available_language_codes
      .map((c) => String(c).trim())
      .filter(Boolean);
  }

  // brak listy → jeden kod główny
  if (company.default_language_code) {
    return [String(company.default_language_code).trim()].filter(Boolean);
  }

  return [];
}

export function companySupportedLanguageCodesExceptDefault(
  company: ICompany | null | undefined
): string[] {
  const defaultNorm = norm((company?.default_language_code ?? '').trim());

  // kolejność jak w `available_language_codes` z API
  return companySupportedLanguageCodes(company).filter(
    (code) => norm(code) !== defaultNorm // główny jest w polu name
  );
}
